import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import BackButton from '@ts-core/components/BackButton';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';

import CourseForm from '../../components/CourseForm';
import { useCourse, useCourseActions } from '../../hooks';
import { CourseFormInput } from '../../types/form';

const EditCoursePage = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const { course, loading } = useCourse({
    courseId,
  });
  const { updatingCourse, onUpdateCourse } = useCourseActions();

  const handleUpdateCourse = useCallback(
    (input: CourseFormInput) => {
      onUpdateCourse(courseId, input);
    },
    [courseId, onUpdateCourse]
  );

  return (
    <Box>
      <Box mb={2}>
        <BackButton title={course?.name} subtitle="Courses" href="/courses" />
      </Box>
      <PageContentLayout>
        {loading ? <CircularProgress /> : <CourseForm course={course} onSubmit={handleUpdateCourse} isSubmitting={updatingCourse} />}
      </PageContentLayout>
    </Box>
  );
};

export default EditCoursePage;
